<template>
    <div class="section qualita" v-if="this.dataLoaded">
        <div class="container">
            <h1 data-aos="new-animation" data-aos-init="aos-init" class="animated-title" data-aos-delay="4000" v-html="this.page.attributes.title"></h1>
            <p class="description" v-html="this.page.attributes.field_description.processed"></p>

            <div class="downloadq">
                <img class="quality-logo" src="../assets/quality-logo.png" :alt="this.altLogo">
                <a :href="'./'+this.pdf" :download="this.pdf">
                    <img class="download-button" :src="require('../assets/'+this.downloadSrc)" :alt="this.altDownload">
                    <div class="download-text">{{this.downloadText}}</div>
                </a>
            </div>

        </div>
    </div>
</template>
<script>
export default {
  name: 'section-qualita',
  props: {
        dataPages: {
            type: String
        },
        langData: String
    },
    data:()=>{
        return {
            idIntroPage:"ea8cc9a7-73ee-4bb4-81a9-960462ab0936",
            page:[],
            dataLoaded:false
        }
    },
    methods: {
        splittedTitle: function (value) {
            return value.replace(/(?![^<]*>)[^<]/g, c => `<span>${c}</span>\n`);
        },
        findObjectbyKey(array, key, value){
            for (var i = 0; i < array.length; i++) {
                if (array[i][key] === value) {
                    return array[i];
                }
            }
            return null;
        }
    },
    computed: {
        altLogo() {
            return this.langData==="it" ? 'logo qualità' : 'quality logo';
        },
        altDownload() {
            return this.langData==="it" ? 'scarica certificazione' : 'download certification';
        },
        downloadSrc() {
            //return this.langData==="it" ? "download-logo-full-it-2.png" : "download-logo-full-en-2.png";
            return "download-logo.svg"
        },
        pdf() {
            return this.langData==="it" ? 
                "ISO-9001-115037-2012-AQ-ITA-ACCREDIA-4-it-IT-20240516.pdf" : 
                "ISO-9001-115037-2012-AQ-ITA-ACCREDIA-4-en-US-20240516.pdf"
        },
        downloadText() {
            return this.langData==="it" ? 'Scarica certificazione' : 'Download certification';
        }
    },
    mounted(){
        fetch("https://ptnlex-api-prod.interfase.tv/"+this.$route.params.lang+"/jsonapi/node/page", {method: "GET", mode: 'cors'})
        .then(response=>{
            return response.json()
        })
        .then(json=>{
            this.page = this.findObjectbyKey(json.data,"id",this.idIntroPage)
            this.dataLoaded = true
        })
        .catch(function(error) {  
            console.log('Request failed', error)  
        });

        //console.log('download lang', this.langData)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h1, p{
    color: #fff;
}
.qualita {
    overflow: hidden;
    background: #14182E;
    height: auto;
    h1 {
        text-transform: uppercase;
        font-size: 2.5rem;
    }
}
.description {
    column-count: 2;
    position: relative;
    &:before {
        background: url("./../assets/certificato-qualità.png");
        content: "";
        display: block;
        position: absolute;
        right: -128px;
        top: -110px;
        width: 207px;
        z-index: 0;
        height: 207px;
        transform-origin: center;
    }
}

@media (max-width: 992px){
   
    .description {
        column-count: 2;
    }
}
@media (max-width:768px){
    .qualita h1 {
        font-size: 1.8rem;
        line-height: 2.4rem;
    }
    .description {
        column-count: 1;
    }

}
.downloadq {
    position: relative;
    width: 100%;
    margin: 0 auto;

    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    
    .quality-logo {
        height: 128px;
        width: auto;
    }

    .download-button {
        height: 4em;
        width: auto;

        display: inline-block;
        vertical-align: top;
        margin-left: 2.5em;
    }

    .download-text {
        width: 100px;
        height: auto;
        font-size: 17px;
        
        display: inline-block;
        vertical-align: middle;
        margin-left: 1em;
        font-weight: 500;

        color: #F04533;
        
        &:hover {
            text-decoration: underline;
            color: lighten(#F04533, 10%);
        }
    }

    @media screen and (max-width: 800px) {
        justify-content: center;

        .quality-logo {
            height: 5em;
        }

        .download-button {
            height: 2.5em;
            width: auto;
        }

        .download-text {
            font-size: 13px;
        }
    }

}

</style>
